import LoadingImg from 'Image/loading.gif';

const Loading = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, 
    }}>
      <img src={LoadingImg} alt="로딩 이미지" style={{ backgroundColor : '#9CBEDD', borderRadius : '50%'}} />
    </div>
  );
};

export default Loading;
